import React from 'react';
import clsx from 'clsx';
import {
  getTierCatalogEntry,
  RiskTierNumber,
  TIER_CATALOG,
} from '../../tiers/tierCatalog';

type Variant = 'default' | 'inactive' | 'unassigned';

interface Props {
  riskTier?: RiskTierNumber | number | null;
  label?: string;
  variant?: Variant;
  size?: 'sm' | 'md';
  className?: string;
}

const TierChip: React.FC<Props> = ({
  riskTier,
  label,
  variant = 'default',
  size = 'sm',
  className,
}) => {
  if (variant === 'unassigned' || riskTier == null) {
    return (
      <span
        className={clsx(
          'inline-flex rounded-full border border-dashed border-gray-300 bg-gray-50 text-gray-600 font-medium',
          size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
          className,
        )}
      >
        {label ?? 'Unassigned'}
      </span>
    );
  }

  const entry = getTierCatalogEntry(riskTier);
  const catalog = entry ?? TIER_CATALOG[riskTier as RiskTierNumber];

  return (
    <span
      className={clsx(
        'inline-flex rounded-full border font-medium',
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
        variant === 'inactive'
          ? 'border-gray-200 bg-gray-100 text-gray-500'
          : catalog.chipClass,
        className,
      )}
      title={catalog.name}
    >
      {label ?? `${catalog.shortName} · ${catalog.name.split('/')[0].trim()}`}
    </span>
  );
};

export default TierChip;
